import { Outlet, createFileRoute } from '@tanstack/react-router';

import CrumbContainer from '~/shared/CrumbContainer';

export const Route = createFileRoute('/_app/settings')({
	beforeLoad: () => {
		return {
			getTitle: 'Settings'
		};
	},
	component: function Component() {
		return <CrumbContainer container={<Outlet />} />;
	}
});
